<template>
  <div class="columns is-multiline is-marginless is-main-content is-paddingless"
       v-if="critereRecherche">
    <div class="column is-12 pdb-0 hauteur-haut-brief-filtre">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('general.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('general.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div class="column is-12 is-marginless overflow-auto hauteur-brief-filtre">
        <div class="column is-12 pdb-0">
            <b-field :label="$t('listeFormatAffiche.filtres.codes')">
                <qd-taginput v-model="critereRecherche.codes" type="is-primary">
                </qd-taginput>
            </b-field>
        </div>
        <div class="column is-12 pdb-0">
            <b-field :label="$t('listeFormatAffiche.filtres.libelle')">
                <b-input v-model="critereRecherche.libelle">
                </b-input>
            </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <libelle-tag-input
            :label="$t('listeFormatAffiche.filtres.natureSupport')"
            :items="natureSupports"
            field="libelle"
            v-model="natureSupportSelected">
          </libelle-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <libelle-tag-input
            :label="$t('listeFormatAffiche.filtres.materielType')"
            :items="materielTypes"
            field="libelle"
            v-model="materielTypeSelected">
          </libelle-tag-input>
        </div>
        <div class="column is-12 pdb-0">
            <b-field :label="$t('listeFormatAffiche.filtres.hauteurs')">
                <qd-taginput v-model="critereRecherche.longueurs" type="is-primary">
                </qd-taginput>
            </b-field>
        </div>
        <div class="column is-12 pdb-0">
            <b-field :label="$t('listeFormatAffiche.filtres.largeurs')">
                <qd-taginput v-model="critereRecherche.largeurs" type="is-primary">
                </qd-taginput>
            </b-field>
        </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()">
        {{$t('general.button.appliquer')}}
      </button>

      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()">
        {{$t('general.button.reinitialiser')}}
      </button>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { SET_CRITERES_RECHERCHE, RESET_CRITERES_RECHERCHE } from '@/store/modules/parametrage/formatAffiche-mutation-type';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import libelleTagInput from '@/components/general/tagInput/libelleTagInput';
import tagInputToArray from '@/services/general/filters/tagInputToArray';

const FormatAffiche = createNamespacedHelpers('formatAffiche');
const Parametres = createNamespacedHelpers('parametres');

export default {
  data() {
    return {
      critereRecherche: null,
      natureSupportSelected: [],
      materielTypeSelected: [],
    };
  },
  components: {
    libelleTagInput,
  },
  computed: {
    ...FormatAffiche.mapGetters({
      criteresRechercheFromStore: 'criteresRecherche',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    natureSupports() {
      return this.parametre(PARAMETRES_KEYS.natureSupportAffiche).filter(n => n.actif);
    },
    materielTypes() {
      return this.parametre(PARAMETRES_KEYS.materielType).filter(m => m.actif);
    },
  },
  methods: {
    ...FormatAffiche.mapMutations({
      setCritereRecherche: SET_CRITERES_RECHERCHE,
      resetCritereRecherche: RESET_CRITERES_RECHERCHE,
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    viderCritere() {
      this.resetCritereRecherche();
      this.natureSupportSelected = [];
      this.materielTypeSelected = [];
      this.initializeFiltre();
    },
    appliquerCritere() {
      const critere = cloneDeep(this.critereRecherche);
      critere.natureSupportAfficheIds = tagInputToArray(this.natureSupportSelected, 'id') ?? [];
      critere.typeMaterielIds = tagInputToArray(this.materielTypeSelected, 'id') ?? [];
      this.setCritereRecherche(critere);
      this.$emit('recherche');
      this.$emit('toggleFiltre');
    },
    initializeFiltre() {
      this.critereRecherche = cloneDeep(this.criteresRechercheFromStore);
      if (this.critereRecherche?.natureSupportAfficheIds?.length) {
        this.natureSupportSelected = this.natureSupports
          .filter(n => this.critereRecherche.natureSupportAfficheIds.includes(n.id));
      }
      if (this.critereRecherche?.typeMaterielIds?.length) {
        this.materielTypeSelected = this.materielTypes
          .filter(n => this.critereRecherche.typeMaterielIds.includes(n.id));
      }
    },
  },
  async mounted() {
    this.initializeFiltre();
    await this.loadParametres([PARAMETRES_KEYS.materielType, PARAMETRES_KEYS.natureSupportAffiche]);
  },
};
</script>
